import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import {SidePanel} from 'front-onceforall-core';

import authenticationService from '../../../../services/authentication/AuthenticationService';
import projectService from '../../../../services/project/ProjectService';
import {captureError} from '../../../../utils/log';
import {addError} from '../../../../actions/snackbars';

import ProjectInternalNotes from '../../ProjectInternalNotes';

function InternalNotesSidePanel(props) {
  const triggerCloseInternalNotesRef = React.useRef();
  const [internalNotes, setInternalNotes] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const dispatch = useDispatch();

  const fetchInternalNotes = () => {
    setLoading(true);
    projectService.getInternalNotes(props.projectId)
      .then(response => {
        setInternalNotes(response);
        props.setNbInternalNotesCallback(response.length);
      })
      .catch(error => {
        captureError('projectService.getInternalNotes', error);
        dispatch(addError(<Translate value="error.generic"/>));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (authenticationService.roles().isBackOffice()) {
      fetchInternalNotes();
    }
  }, []);

  if (!props.isOpen) {
    return null;
  }

  return (
    <SidePanel
      onClose={props.onClose}
      setCloseTrigger={close => {
        triggerCloseInternalNotesRef.current = close;
      }}
    >
      <ProjectInternalNotes
        internalNotes={internalNotes}
        onClose={triggerCloseInternalNotesRef?.current}
        onNewInternalNote={fetchInternalNotes}
        projectId={props.projectId}
        loading={loading}
      />
    </SidePanel>
  );
}

InternalNotesSidePanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  projectId: PropTypes.number.isRequired,
  setNbInternalNotesCallback: PropTypes.func.isRequired
};

export default InternalNotesSidePanel;
